module.exports = __webpack_public_path__ + "static/media/apple-large.9838ec90.svg";